import React, { useRef, useEffect, useState, useCallback } from 'react';
import TabBar from './TabBar.js'
import './SideBar.css'
import Contact from './Contact.js'
import River from "../assets/wave-1-svgrepo-com.svg"
import CloseButton from 'react-bootstrap/CloseButton'


export default function SideBar(props) {


    function onCloseCallback(x) {
        props.closeSideBar()
    }

    return (
        <div className='sidebar-contents' data-testid="sidebar-test">
            <CloseButton className='close-button' onClick={onCloseCallback}></CloseButton>
            { (props.searchResult != "") && <div className='address' data-testid="searchresult-test">
                <h1 className="title">{props.searchResult}<img data-testid="sidebaricon-river-test" className='address-icon' src={River}></img></h1>
            </div> }
            <TabBar census={props.census} addressFound={props.addressFound} searchResult={props.searchResult} parcel={props.parcel}></TabBar>
            <div className='contact-bar'>
                <Contact></Contact>
            </div>
        </div>
    )
}